'use client';

import { useEffect } from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('[app/error]', error);
  }, [error]);

  return (
    <div
      className="mo-design"
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--page-bg)',
        padding: 'clamp(16px, 4vw, 32px)',
      }}
    >
      <div
        style={{
          maxWidth: 480,
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          gap: 18,
          background: 'var(--card-bg)',
          padding: 'clamp(28px, 5vw, 44px)',
          borderRadius: 14,
          border: '1px solid rgba(0,0,0,0.06)',
        }}
      >
        <span
          style={{
            color: 'var(--coral-deep)',
            fontFamily: 'var(--font-plex-mono), ui-monospace, monospace',
            fontSize: 11,
            letterSpacing: '0.22em',
            textTransform: 'uppercase',
          }}
        >
          Something went wrong
        </span>
        <h1
          style={{
            fontFamily: 'var(--font-playfair), Georgia, serif',
            fontWeight: 500,
            fontSize: 'clamp(24px, 4vw, 32px)',
            lineHeight: 1.2,
            margin: 0,
          }}
        >
          We hit an unexpected snag.
        </h1>
        <p
          style={{
            fontFamily: 'var(--font-zalando-sans-narrow), system-ui, sans-serif',
            fontSize: 15,
            lineHeight: 1.55,
            color: 'rgba(0,0,0,0.65)',
            margin: 0,
          }}
        >
          The error has been logged. Try again in a moment, or head back home.
        </p>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={reset}
            style={{
              background: 'var(--coral-deep)',
              color: '#fff',
              border: 'none',
              padding: '10px 18px',
              borderRadius: 8,
              fontFamily: 'var(--font-zalando-sans-narrow), system-ui, sans-serif',
              fontSize: 14,
              fontWeight: 500,
              cursor: 'pointer',
            }}
          >
            Try again
          </button>
          <a
            href="/"
            style={{
              background: 'transparent',
              color: 'var(--coral-deep)',
              border: '1px solid var(--coral-deep)',
              padding: '10px 18px',
              borderRadius: 8,
              fontFamily: 'var(--font-zalando-sans-narrow), system-ui, sans-serif',
              fontSize: 14,
              fontWeight: 500,
              textDecoration: 'none',
            }}
          >
            Go home
          </a>
        </div>
        {error.digest && (
          <span
            style={{
              fontFamily: 'var(--font-plex-mono), ui-monospace, monospace',
              fontSize: 11,
              color: 'rgba(0,0,0,0.4)',
              marginTop: 8,
            }}
          >
            ref · {error.digest}
          </span>
        )}
      </div>
    </div>
  );
}
